<template>
  <div class="user-selector-container">
    <ul class="uk-list">
      <template v-if="users">
        <li
          v-for="user in users"
          :key="user.id"
          :class="{
            selectable: selectable,
            active: readOnly && currentUser && user.id === currentUser.id
          }"
          @click="!user.disabled && readOnly && onUserClick(user)"
        >
          <label class="user-selector-item" :for="user.name">
            <div class="selector" v-if="!readOnly">
              <input
                type="checkbox"
                :name="user.id"
                :disabled="user.disabled"
                :checked="user.selected"
                @change="onSelectionChange($event, user)"
              />
            </div>
            <Avatar :clickable="false" :image="user.image" />
            <span class="name">{{ user.lastName }} {{ user.firstName }}</span>
          </label>
        </li>
      </template>
      <template v-else-if="isReading"><div style="margin:16px;">読み込み中...</div></template>
      <template v-else></template>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.user-selector-container {
  border: 1px solid $border-color-secondary;
  overflow-y: auto;
}
.user-selector-item {
  display: flex;
  align-items: center;
  .avatar-container {
    margin-right: $spacing-small;
  }
  .selector {
    margin-right: $spacing-small;
  }
}
.uk-list {
  margin: 0;
  padding: 0;
  margin-top: 0 !important;
  li {
    padding: $spacing-small;
    margin-top: 0 !important;
    &.active {
      background-color: $brand-color;
      .name {
        color: #fff;
      }
    }
  }
}
.selectable {
  label {
    cursor: pointer;
  }
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import Avatar from "../atoms/Avatar.vue";
import { SelectableProfile } from "../../types";

@Options({
  components: { Avatar }
})
export default class UserSelector extends Vue {
  @Prop({ type: Array }) users: SelectableProfile[] = [];
  @Prop({ type: String }) userType: "employee" | "applicants" = "employee";
  @Prop({ type: String }) departmentId = "all";
  @Prop({ type: Boolean }) readOnly = true;
  @Prop({ type: Boolean }) selectable = true;
  @Prop({ type: Boolean }) isReading = false;
  currentUser: Partial<SelectableProfile> = {};
  onSelectionChange(event: Event, selectedUser: SelectableProfile) {
    const target = event.target as HTMLInputElement;
    this.$emit(
      "selection-change",
      Object.assign({}, selectedUser, {
        selected: target.checked
      })
    );
  }
  @Emit("user-click")
  onUserClick(selectedUser: SelectableProfile) {
    if (selectedUser !== this.currentUser) {
      this.currentUser = selectedUser;
    }
    return Object.assign({}, selectedUser, { selected: !!this.currentUser.id });
  }
}
</script>
